// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint-disable */
export const VERSION: any = {
  "branch": "master",
  "sha": "7b989df8626f1a99f1b9cda612984b47f92adef0",
  "abbreviatedSha": "7b989df8",
  "tag": "2026.03.2",
  "lastTag": "2026.03.2",
  "commitsSinceLastTag": 0,
  "version": "2026.03.2",
  "commitCount": 2736
};
/* eslint-enable */
